import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.selectedFactoryName.includes('外來監控') ? _c('div', {
    staticClass: "pageTitle"
  }, [_vm._v(" " + _vm._s(_vm.selectedFactoryName) + " ")]) : _c('div', {
    staticClass: "realtime_Multiselect"
  }, [_c('multiselect', {
    ref: "multiselectRef",
    attrs: {
      "options": _vm.getFactoryInfoNameList,
      "placeholder": "案場名稱",
      "max-height": 600,
      "preserveSearch": true,
      "allow-empty": false,
      "show-labels": false,
      "clear-on-select": false
    },
    on: {
      "select": _vm.handleSelectFactoryName,
      "open": _vm.handleOpenFactoryNameSelection
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(props) {
        return [_c('span', [_vm._v(_vm._s(props.option))]), _c('i', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: '複製名稱',
            expression: "'複製名稱'"
          }],
          staticClass: "far fa-copy copy-button ml-4",
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.copyToClipboard(props.option);
            }
          }
        })];
      }
    }]),
    model: {
      value: _vm.selectedFactoryName,
      callback: function callback($$v) {
        _vm.selectedFactoryName = $$v;
      },
      expression: "selectedFactoryName"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" 查詢無資料，請重新搜尋 ")])]), _vm.routeQuery.demo === 'true' && _vm.hasRoleAdmin ? _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: _vm.tooltipDisplaySiteName(_vm.routeQuery.demo),
      expression: "tooltipDisplaySiteName(routeQuery.demo)",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "ml-2 peekDisplayNameBtn"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })]) : _vm._e()], 1), _c('div', {
    staticClass: "category-wrapper"
  }, _vm._l(_vm.navbarList, function (item) {
    return _c('router-link', {
      key: item.name,
      attrs: {
        "to": {
          name: item.name,
          query: _vm.routeQuery
        }
      }
    }, [_c('div', {
      staticClass: "info-category",
      class: {
        active: _vm.routeName === item.name
      }
    }, [_c('i', {
      class: "".concat(item.icon, " m-5px")
    }), _vm._v(_vm._s(item.zhTw) + " ")])]);
  }), 1), _c('router-view')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };